import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list
 */
export default class BlogPostsList extends PaginatedList {
  #resizeObserver;
  #mutationObserver;
  #frame;
  #width = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#resizeObserver = new ResizeObserver(([entry]) => {
      if (entry.contentRect.width === this.#width) return;
      this.#width = entry.contentRect.width;
      this.#scheduleAlignment();
    });
    this.#resizeObserver.observe(this.querySelector('.blog-posts-container') || this);
    this.#mutationObserver = new MutationObserver(() => this.#scheduleAlignment());
    this.#mutationObserver.observe(this, { childList: true, subtree: true });
    document.fonts.ready.then(() => {
      if (this.isConnected) this.#scheduleAlignment();
    });
    this.#scheduleAlignment();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#resizeObserver?.disconnect();
    this.#mutationObserver?.disconnect();
    cancelAnimationFrame(this.#frame);
  }

  #scheduleAlignment() {
    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(() => this.#alignRows());
  }

  #alignRows() {
    const cards = Array.from(this.querySelectorAll('.blog-post-item'));
    const selectors = ['.blog-post-card__content > a:first-child', '.blog-post-card__description'];
    for (const card of cards) {
      for (const selector of selectors) card.querySelector(selector)?.style.removeProperty('min-height');
    }
    if (window.innerWidth < 750) return;

    const rows = new Map();
    for (const card of cards) {
      const top = Math.round(card.getBoundingClientRect().top);
      if (!rows.has(top)) rows.set(top, []);
      rows.get(top).push(card);
    }
    for (const row of rows.values()) {
      for (const selector of selectors) {
        const elements = row.map((card) => card.querySelector(selector)).filter(Boolean);
        const height = Math.max(0, ...elements.map((element) => element.getBoundingClientRect().height));
        for (const element of elements) element.style.minHeight = `${height}px`;
      }
    }
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
